import React, { createContext } from "react"
import data from "../data.json"

export const StaticDataContext = createContext({
  tariffs: [],
  dbTypes: [],
  allTariffs: [],
})

const StaticDataContextProvider = ({ children }) => {
  const rawTariffs = Array.isArray(data?.tariff?.items) ? data.tariff.items : []

  const decodeBufferLikeString = value => {
    if (typeof value === "string") {
      return value
    }

    if (value == null) {
      return value
    }

    if (typeof Buffer !== "undefined" && Buffer.isBuffer?.(value)) {
      try {
        return value.toString("utf8")
      } catch (_) {
        return ""
      }
    }

    if (typeof value === "object" && value.type === "Buffer" && Array.isArray(value.data)) {
      try {
        const bytes = Uint8Array.from(value.data)
        if (typeof TextDecoder !== "undefined") {
          return new TextDecoder("utf-8").decode(bytes)
        }
        if (typeof Buffer !== "undefined") {
          return Buffer.from(bytes).toString("utf8")
        }
      } catch (_) {
        return ""
      }
    }

    if (typeof TextDecoder !== "undefined" && value instanceof Uint8Array) {
      try {
        return new TextDecoder("utf-8").decode(value)
      } catch (_) {
        return ""
      }
    }

    return value
  }

  const toNumberOrNull = value => {
    const numberValue = Number(value)
    return Number.isFinite(numberValue) ? numberValue : null
  }

  const compareTariffs = (a, b) => {
    const aSortOrder = toNumberOrNull(a?.sort_order)
    const bSortOrder = toNumberOrNull(b?.sort_order)

    if (aSortOrder != null || bSortOrder != null) {
      return (
        (aSortOrder ?? Number.MAX_SAFE_INTEGER) -
          (bSortOrder ?? Number.MAX_SAFE_INTEGER) ||
        (toNumberOrNull(a?.days) ?? 0) - (toNumberOrNull(b?.days) ?? 0) ||
        (toNumberOrNull(a?.integrations) ?? 0) -
          (toNumberOrNull(b?.integrations) ?? 0) ||
        (toNumberOrNull(a?.id) ?? 0) - (toNumberOrNull(b?.id) ?? 0)
      )
    }

    return (
      (toNumberOrNull(a?.days) ?? 0) - (toNumberOrNull(b?.days) ?? 0) ||
      (toNumberOrNull(a?.integrations) ?? 0) -
        (toNumberOrNull(b?.integrations) ?? 0) ||
      (toNumberOrNull(a?.id) ?? 0) - (toNumberOrNull(b?.id) ?? 0)
    )
  }

  const rawTariffsNormalized = rawTariffs.map(tariff => {
    const title = decodeBufferLikeString(tariff?.title)
    const code = decodeBufferLikeString(tariff?.code)

    return {
      ...tariff,
      title: typeof title === "string" ? title : "",
      code: typeof code === "string" ? code : null,
    }
  })

  const allTariffs = [...rawTariffsNormalized].sort(compareTariffs)
  const tariffs = allTariffs.filter(tariff => tariff?.is_visible !== false)

  const dbTypes = Array.isArray(data?.dbTypes) ? data.dbTypes : []

  const value = {
    tariffs,
    dbTypes,
    allTariffs,
  }

  return (
    <StaticDataContext.Provider value={value}>
      {children}
    </StaticDataContext.Provider>
  )
}
export default StaticDataContextProvider
